import { authHeader } from '../utils/auth-header';
import apis from '../config/api';
import axios from "axios";

export const paymentService = {
    createCardPayment,
    getPaymentDetails,
    updateCardMethod
};

function createCardPayment(cardDetail){
    return axios.post(`${apis.payment}/CreateCardMethod`, cardDetail,{ headers: authHeader() });
}

function getPaymentDetails() {
    return axios.get(`${apis.payment}/GetPaymentDetails`, { headers: authHeader() });
}

function updateCardMethod(id, paymentMethod) {
    return axios.put(`${apis.payment}/UpdateCardMethod/${id}`, paymentMethod,{ headers: authHeader() });
}







// WEBPACK FOOTER //
// ./src/services/paymentService.js